import React, { useEffect, useMemo, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Mdatatable from "components/Datatables/Mdatatables";
import Notifications from "components/Notifications";
import DeleteConfirmationModel from "components/delete-confirmation-model";
import { getCode, userModuleData } from 'helpers/basic_helper';
import { MASTER_OPTIONS_URL } from "helpers/url_helper";
import { useDispatch, useSelector } from 'react-redux';
import { masterOptions } from 'store/actions';
import { GetHelper, SubmitHelper } from '../CallHelper';
import FormComponent from "../FormComponent";
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";

const isType = 'stations'
const Station = props => {
    const dispatch = useDispatch()
    const {DDMasters } = useSelector(state => state.Master);
    const [open, isOpen] = useState(false)
    const [editableObj, setEditableObj] = useState(null)
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isEdit, setIsEdit] = useState(false)
    const [isDeleteModel, setIsDeleteModel] = useState(false)
    const [isActions, setIsActions] = useState(false)
    const [isActionColumn, setIsActionColumn] = useState(false)
    const [error, setError] = useState(false)
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })
    
    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(handler);
    }, [pagination]);

    useEffect(async() => {
        const data =  await userModuleData('masters', 'stations')
        setIsActions(data)
        if(data && (data?.edit || data?.delete)){
            setIsActionColumn(true)
        }
    }, [])

    /**
     * Get All Rows
     * @param {row_id} ID 
     * @method {get} GET 
     */
    const getData = async(ID = false) => {
        if (!ID) setIsLoading(true)
        const res = await GetHelper(`${process.env.REACT_APP_STATIONS}&page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`, ID)
        if(ID){
            setEditableObj(...res)
            isOpen(true)
            setIsEdit(false)
        }else{
            setDataRows(res)
        }

        setIsLoading(false)
        if(res === undefined){
            setError(true)
        }
    }

    useEffect(() => {
        dispatch(masterOptions({url:MASTER_OPTIONS_URL}))   
    },[])
    
    /**
     * Submit or Update data Api Call
     * @param {Form Data} data 
     * @method {post} POST 
     */
    const submitForm = async(data) => {
        const checkCode = dataRows?.rows?.filter(v => (v.code).toUpperCase() == (data.target.code.value).toUpperCase())
        if(data?.target?.id?.value =='' && checkCode.length > 0) {
            Notifications('please enter unique code.!', 'error')
            return;
        }

        setIsLoading(true)
        const res = await SubmitHelper(`${process.env.REACT_APP_STATIONS}&page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`, {
            "title": data.target.title.value,
            "code": data.target.code.value,
            "country": data.target.country.value,
            "state": data.target.state.value,
            "city": data.target.city.value
        }, data?.target?.id?.value || null);
        
        if(res){
            getData()
            setIsLoading(false)
            isOpen(false)
            Notifications('You have successfully added a Station.!')
        }
    }

    /**
     * Get Single row using url params ?q=?
     * @param {Row_id} q 
     * @method {get} GET 
     */
    const handleEdit = q => {
        if(q > 0){
            setIsEdit(q)
            getData(q)
        }
    }

    /**
     * Chnage Row Status By ID and condition Based Status passing,
     * @param {row_id} q 
     * @param {row Status} status 
     * @method {del} DELETE 
     */
    const handleRemove = async(q, status, code) => {
        if(q > 0) {
            setIsDeleteModel({url: process.env.REACT_APP_STATIONS, q, status, code})
        }
    }
    const hideModel = () => {
        setIsDeleteModel(false)
        getData()
    }

    /**
     * DataTable with Condition based row formating
     */
    let datatableData = useMemo(
        () => [
        {
            dataField: 'id',
            text: '#',
            enableHiding: true
        },{
            dataField: 'title',
            text: 'Station'
        }, {
            dataField: 'code',
            text: 'Code'
        }, {
            dataField: 'city_title',
            text: 'City'
        }, {
            dataField: 'state_title',
            text: 'State'
        }, {
            dataField: 'country_title',
            text: 'Country'
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <>
                <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id)} title="Track or status" ><i className={`fas fa-pencil-alt`} /></Link>
                <Link to="#" className="ms-1 btn btn-outline-danger btn-sm edit" onClick={() => handleRemove(row.id, row.status, row.code)} title="Track or status" ><i className={`fas fa-trash-alt`} /></Link>
            </>
        }
        ],
    );

    /**
     * HTML Form Columns 
     */
    let htmlFormFields = [
        {
            name: "id",
            required: false,
            type: 'hidden',
            value: editableObj ? editableObj.id : '',
            col: 12
        }, {
            name: "title",
            label: "Station Name",
            placeholder: "Station Name",
            required: true,
            type: 'text',
            value: editableObj ? editableObj.title : '',
            col: 12
        }, {
            name: "code",
            label: "Code",
            placeholder: "Code",
            required: true,
            type: 'text',
            value: editableObj ? editableObj.code : getCode("stations", dataRows?.total_rows),
            col: 12
        }, {
            name: "country",
            label: "Country",
            placeholder: "Country",
            required: true,
            type: 'select',
            options: DDMasters?.countries?.map( v => ({'label': v.title, 'value': v.code})),
            value: editableObj ? DDMasters?.countries?.filter(v => v.code == editableObj.country).map( v => ({'label': v.title, 'value': v.code})) : '',
            col: 12
        }, {
            name: "state",
            label: "State",
            placeholder: "State",
            type: 'select',
            options: DDMasters?.states?.map( v => ({'label': v.title, 'value': v.code})),
            value: editableObj ? DDMasters?.states?.filter(v => v.code == editableObj.state).map( v => ({'label': v.title, 'value': v.code})) : '',
            col: 12
        }, {
            name: "city",
            label: "City",
            placeholder: "City",
            required: true,
            type: 'select',
            options: DDMasters?.cities?.map( v => ({'label': v.title, 'value': v.code})),
            value: editableObj ? DDMasters?.cities?.filter(v => v.code == editableObj.city).map( v => ({'label': v.title, 'value': v.code})) : '',
            col: 12
        }
    ]
    
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Dashboard | {isType}</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Masters" breadcrumbItem={isType} />
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables 
                                        isSearch={true}
                                        columns = {datatableData}
                                        showTableOnly={true}
                                        rowsLength = {dataRows?.total_rows || 0}
                                        rows = {dataRows?.rows || []}
                                        keyField={'id'}
                                        handleAddButton={()=>{
                                            setEditableObj(null)
                                            isOpen(true)
                                        }}            
                                        title = "All Stations"
                                        loading={isLoading}
                                        isAdd = {true}
                                        isTableHead = {true}
                                        ssr={setPagination}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Datatable */}
            {
                open && 
                <FormComponent
                    title={`${editableObj ? 'Edit' : 'Add'} Station`}
                    Position={"right"}
                    isOpen={open}
                    fileds={htmlFormFields}
                    loading={isLoading}
                    editableObj={editableObj}
                    onDrawerClose={(e) => {
                        setEditableObj(null)
                        isOpen(false)
                    }}
                    submitForm={submitForm}
                />
            }
            {/* End Datatable */}

            { isDeleteModel && <DeleteConfirmationModel isOpen={true} changeState={hideModel} code={isDeleteModel} /> }
        </React.Fragment>
    )
}

export default Station
